module.exports = __webpack_public_path__ + "static/media/impact-uba.6d07d600.png";